export default function highlightActive(path) {
    // we'll check for the root links first
    const directLinks = $('.side-nav > li > a');

    // if there aren't any links, there probably isn't a nav on this page
    if(!directLinks.length) {
        return false;
    }

    // if we successfully found a candidate to highlight, then exit
    if(findActiveLinkCandidate(path, directLinks, true)) {
        return true;
    }

    // next we'll check for links nested in collapsible headers
    const collapsible = $('.side-nav > li > .collapsible > li');

    // check if there are any on this page
    if(!collapsible.length) {
        return false;
    }

    for(const ele of collapsible) {
        const links = $(ele).find('a');
        if(findActiveLinkCandidate(path, links, false)) {
            // the first link should be the collapsible header
            // we need to also make it active so that the child link is visible
            links.first().addClass('active');
            return true;
        }
    }

    return false;
}

function findActiveLinkCandidate(path, links, direct) {
    for(const link of links) {
        const href = link.getAttribute('href');
        if (direct) {
            if(href && ~path.indexOf(href)) {
                link.classList.add('active');
                return true;
            }
        } else {
            if(href && path === href) {
                link.classList.add('active');
                return true;
            }
        }
    }
    return false;
}